import React from 'react';

export default () => (
  <svg
    width='60'
    height='61'
    viewBox='0 0 60 61'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M23.8395 27.0055V28.0055H24.8395H34.7995H35.7995V27.0055V19.9855C35.7995 16.6732 33.1317 14.0055 29.8195 14.0055C26.5072 14.0055 23.8395 16.6732 23.8395 19.9855V27.0055ZM17.4395 34.4055V19.9855C17.4395 13.1578 22.9917 7.60547 29.8195 7.60547C36.6472 7.60547 42.1995 13.1578 42.1995 19.9855V34.4055H17.4395Z'
      stroke='#06292F'
      stroke-width='2'
    />
    <path
      d='M47.7008 53.4255H11.9408C11.9072 53.4255 11.869 53.4112 11.8399 53.3831C11.8266 53.3703 11.8173 53.3565 11.8114 53.3429C11.8059 53.3302 11.8008 53.3123 11.8008 53.2855V26.9455C11.8008 26.9119 11.8151 26.8737 11.8431 26.8446C11.856 26.8313 11.8698 26.822 11.8834 26.8161C11.8961 26.8106 11.914 26.8055 11.9408 26.8055H47.7008C47.7344 26.8055 47.7726 26.8198 47.8016 26.8478C47.815 26.8607 47.8242 26.8745 47.8302 26.8881C47.8357 26.9008 47.8408 26.9187 47.8408 26.9455V53.2855C47.8408 53.3285 47.8332 53.3553 47.8274 53.3696C47.8217 53.3838 47.8156 53.3914 47.8112 53.3959C47.8067 53.4003 47.7991 53.4064 47.7849 53.4121C47.7706 53.4179 47.7438 53.4255 47.7008 53.4255Z'
      fill='#DFF3B2'
      stroke='#06292F'
      stroke-width='2'
    />
    <path
      d='M29.8209 41.7055C32.273 41.7055 34.2609 39.7176 34.2609 37.2655C34.2609 34.8133 32.273 32.8255 29.8209 32.8255C27.3687 32.8255 25.3809 34.8133 25.3809 37.2655C25.3809 39.7176 27.3687 41.7055 29.8209 41.7055Z'
      fill='#97D700'
    />
    <path
      d='M27.7207 38.4055H31.9807V46.0855C31.9807 47.2855 31.0207 48.1855 29.8807 48.1855C28.6807 48.1855 27.7807 47.2255 27.7807 46.0855V38.4055H27.7207Z'
      fill='#97D700'
    />
  </svg>
);
